import { render } from "./D3ForceGraph.vue?vue&type=template&id=fa5b6992&scoped=true"
import script from "./D3ForceGraph.vue?vue&type=script&lang=js"
export * from "./D3ForceGraph.vue?vue&type=script&lang=js"

import "./D3ForceGraph.vue?vue&type=style&index=0&id=fa5b6992&scoped=true&lang=css"
import "./D3ForceGraph.vue?vue&type=style&index=1&id=fa5b6992&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa5b6992"]])

export default __exports__